import { Card } from "antd";
import React from "react";

const ShopperLoginMobileConatiner = ({ children }) => {
  return <Card>{children}</Card>;
};

export default ShopperLoginMobileConatiner;
